"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStandardWalletAdapters = useStandardWalletAdapters;
var wallet_standard_base_1 = require("@hermis/wallet-standard-base");
var react_1 = require("react");
/**
 * Hook for getting standard wallet adapters
 *
 * This hook integrates with @hermis/wallet-standard-base's
 * getStandardWalletAdapters function to discover and initialize
 * wallet adapters including standard wallets.
 *
 * The base library handles all initialization and change detection automatically.
 *
 * `network` must be supplied explicitly — we do not infer the cluster from the
 * RPC endpoint URL (substring matching is unsafe).
 *
 * @param existingAdapters Existing adapters to include
 * @param endpoint Optional RPC endpoint for mobile wallet adapter
 * @param network Active Solana network for the cluster hint
 * @returns Array of Adapters
 */
function useStandardWalletAdapters(existingAdapters, endpoint, network) {
    var _this = this;
    if (existingAdapters === void 0) { existingAdapters = []; }
    var _a = (0, react_1.useState)(existingAdapters), adapters = _a[0], setAdapters = _a[1];
    // Identity-stable key over the adapter set. Memoising on `.length` would
    // miss swaps where the array length stays the same but the adapters differ.
    var adapterNamesKey = (0, react_1.useMemo)(function () { return existingAdapters.map(function (a) { return a.name; }).join('|'); }, [existingAdapters]);
    // Initial fetch of adapters
    (0, react_1.useEffect)(function () {
        var mounted = true;
        var fetchAdapters = function () { return __awaiter(_this, void 0, void 0, function () {
            var standardAdapters, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, wallet_standard_base_1.getStandardWalletAdapters)(existingAdapters, endpoint, network)];
                    case 1:
                        standardAdapters = _a.sent();
                        if (mounted) {
                            setAdapters(standardAdapters);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error getting standard wallet adapters:', error_1);
                        if (mounted) {
                            setAdapters(existingAdapters);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchAdapters();
        return function () {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adapterNamesKey, endpoint, network]);
    // Subscribe to dynamic adapter changes
    (0, react_1.useEffect)(function () {
        var mounted = true;
        var unsubscribe = (0, wallet_standard_base_1.subscribeToWalletAdapterChanges)(function (updatedAdapters) {
            if (mounted) {
                // The subscription only provides standard wallets, we need to merge with existing adapters
                var mergedAdapters = __spreadArray(__spreadArray([], existingAdapters, true), updatedAdapters, true);
                // Remove duplicates based on adapter name
                var uniqueAdapters = mergedAdapters.filter(function (adapter, index, array) {
                    return array.findIndex(function (a) { return a.name === adapter.name; }) === index;
                });
                setAdapters(uniqueAdapters);
            }
        });
        return function () {
            mounted = false;
            unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adapterNamesKey]);
    return adapters;
}
